<template>
  <header>
    <div class="header-inner">
      <div class="header-l">
        <svg-icon icon-class="menu" @click="drawerVisible=true"/>
        <div class="logo">
          <div class="img-con" @click="goHome">
            <img :alt="title" class="img" src="@/assets/logo.png"/>
          </div>
          <span> {{ title }}</span>
        </div>
      </div>
      <div class="header-m"></div>
      <div class="header-r">
        <!-- 现消息通知 -->
        <el-tooltip content="消息" effect="dark" placement="bottom">
          <el-badge :hidden="msgCount <= 0" :max="99" :value="msgCount">
            <svg-icon icon-class="bell"/>
          </el-badge>
        </el-tooltip>
        <el-popover popper-class="popover_topBar popover_acc" trigger="hover" width="300px">
          <div class="acc">
            <div class="user">
              <el-avatar class="userPic" size="default">
                <el-image :src="headURL" class="img">
                  <template #error><img :src="defaultHeadURL" alt=""/></template>
                  <template #placeholder>
                    <img :src="defaultHeadURL" alt=""/>
                  </template>
                </el-image>
              </el-avatar>
              <span>{{ CurrentUserInfo.User?.DisplayName }}</span>
            </div>
            <div class="oper">
              <router-link to="">
                基本资料
              </router-link>
              <router-link to="">
                修改头像
              </router-link>
              <router-link to="">
                个人设置
              </router-link>
            </div>
          </div>
          <footer>
            <el-button plain text @click="LogOut">
              退出登录
            </el-button>
          </footer>
          <template #reference>
            <el-avatar class="userPic" size="small">
              <el-image :src="headURL" class="img" fit="cover">
                <template #error><img :src="defaultHeadURL" alt=""/></template>
                <template #placeholder>
                  <img :src="defaultHeadURL" alt=""/>
                </template>
              </el-image>
              <div class="avatar-mask">
                <svg-icon icon-class="more"/>
              </div>
            </el-avatar>
          </template>
        </el-popover>
      </div>
    </div>
  </header>
  <el-drawer v-model="drawerVisible" :size="280" :with-header="false" class="menuDrawer" destroy-on-close
             direction="ltr" modal-class="menuModal">
    <header>
      <div class="header-inner">
        <div class="header-l">
          <svg-icon icon-class="menu" @click="drawerVisible=true"/>
          <div class="logo">
            <div class="img-con" @click="goHome">
              <img :alt="title" class="img" src="@/assets/logo.png"/>
            </div>
            <span> {{ siteName }}</span>
          </div>
        </div>
      </div>
    </header>
    <div class="menuWarp">
      <el-tree ref="treeMenuRef" :current-node-key="currentKey" :data="Modules" :default-expanded-keys="expandedKeys"
               :props="defaultProps" class="treeMenu" node-key="ID" @node-click="NavGoTo">
        <template #default="{ node, data }">
          <element-plus-tree-line :node="node" :showLabelLine="true" :treeData="Modules">
            <template #node-label>
                    <span class="viewTitle">
                      <svg-icon :icon-class="data.Module.Icon"/>
                      <slot :data="data" :node="node" name="ViewTreeTitle"/>
                      <!-- 如果是楼层节点-处理楼层tooltip展示内容 -->
                      <el-tooltip :content="node.label" :disabled="!node.label || node.label.length <= 10"
                                  :enterable="false" placement="top">
                        {{ node.label }}
                      </el-tooltip>
                    </span>
            </template>
          </element-plus-tree-line>
        </template>
      </el-tree>
    </div>
  </el-drawer>
</template>
<script lang="ts" setup>
import {computed, inject, onMounted, ref, watch} from "vue";
import {ElMessageBox, ElTree} from 'element-plus'
import {useRoute, useRouter} from "vue-router";
// import api, {PBEntity} from "@mfksoft.ops/api"
import defaultHeadURL from "@/assets/img/default_head.png";

const route = useRoute();
const router = useRouter();
// const RootModules = inject("RootModules") as [PBEntity.Tree];
const defaultProps = {
  children: 'Children',
  label: 'Name',
}
const treeMenuRef = ref<InstanceType<typeof ElTree>>()
const expandedKeys = ref([])
const currentKey = ref("")
const CurrentUserInfo = inject("CurrentUserInfo") as PBEntity.ExUser;
const siteName = computed(() => window.Config.SiteName);
const drawerVisible = ref(false);
const msgCount = ref(0);
const headURL = ref("");
const moduleName = ref("");
const title = computed(() => {
  const paths = route.path.split("/");
  let pPath = "";
  paths.forEach((p, index) => {
    if (index < paths.length - 1 && p) {
      pPath += "/" + p;
    }
  });

  let name = siteName.value;

  const parentRoute = route.matched.find((r) => r.path === pPath);
  if (parentRoute) {
    // GetModuleName(parentRoute.name);
    if (moduleName.value) {
      name = moduleName.value + " - " + name;
    }
  }

  window.document.title = name;
  return name
});
const Modules = ref([]);

onMounted(() => {
  LoadModules()
})

/** 注销 */
const LogOut = async () => {
  ElMessageBox.confirm("请确认是否退出登录?", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
    autofocus: false
  }).then(async () => {
    // const res = await api.Admin.Sys.Logout(store.GetToken(), CurrentUserInfo.User?.Name);
    // removeLoginInfo();
    // RootModules.value.splice(0);
    // if (res && res.Info) {
    //   window.location.href = res.Info;
    // } else {
    //   await doLogin();
    // }
  });

  // if (window.Config && window.Config.UseUnify) {
  //   doLogin();
  // } else {
  //   router.push("/login");
  // }
};

const LoadModules = () => {
  // Modules.value.splice(0);
  // for (const r of RootModules.value) {
  //   if (r.Module?.IsMenu) {
  //     Modules.value.push(r)
  //     if (r.Children && r.Children.length > 0) {
  //       r.Children.forEach(c => {
  //         if (c.Module?.Code === route.name)
  //           expandedKeys.value = [r.Module.Code]
  //       })
  //     }
  //   }
  // }
  // currentKey.value = route.name
}
/** 导航跳转 */
const NavGoTo = (item: any) => {
  router.push(item.Path);
};

watch(
    () => router.currentRoute.value,
    () => LoadModules()
);
// watch(
//     () => RootModules.value,
//     () => LoadModules()
// );
</script>

<style lang="scss" scoped>
$headHeight: 48px;

svg {
  cursor: pointer;
}

header {
  z-index: 100;
  min-height: $headHeight;
  border: 1px solid transparent;
  border-top: 0 solid transparent;
  top: 0;
  position: fixed;
  right: 0;
  left: 0;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  background-image: radial-gradient(transparent 1px, var(#ffffff) 1px);
  background-size: 4px 4px;
  backdrop-filter: saturate(50%) blur(4px);

  .header-inner {
    background-color: rgb(255, 255, 255);
    z-index: 100;
    height: $headHeight;
    display: flex;
    flex: 1 1 auto;
    justify-content: space-between;
    padding: 0 20px;

    .header-l {
      display: flex;
      flex-shrink: 1;
      flex-basis: calc(50vw - 160px);
      flex-direction: row;
      z-index: 5;
      padding-right: 16px;
      align-items: center;

      .menu {
        color: rgb(166, 166, 166);
      }

      :deep(.el-divider--vertical) {
        height: 30px;
        border-left-color: #ddd;
        margin: 0;
      }

      .menu:hover {
        color: rgb(61, 168, 245);
        background: rgba(61, 168, 245, 0.094);
      }

      .logo {
        display: flex;
        align-items: center;
        margin-left: 14px;
        height: 100%;

        .img-con {
          // height: 100%;
          height: calc(100% - 10px * 2);
          // width: $headheight / 1.5;
          cursor: pointer;

          .img {
            width: 100%;
            height: 100%;
          }
        }

        > span {
          margin-left: 8px;
          font-size: 15px;
          font-weight: 600;
          color: #262626;
          line-height: 24px;
        }
      }
    }

    .header-r {
      display: flex;
      align-items: center;

      .space-item {
        width: 36px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;

        .space-img {
          width: 24px;
          height: 24px;
        }
      }

      svg {
        font-size: 20px;
        margin-left: 10px;
        margin-right: 10px;
      }

      > * {
        margin-left: 5px;
      }
    }
  }
}

.el-avatar.userPic {
  cursor: pointer;
  background-color: #ffffff;
  position: relative;

  .avatar-mask {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    opacity: 0;
    width: 28px;
    height: 28px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: rgba(56, 56, 56, .6);
    -webkit-transition: opacity .3s;
    -o-transition: opacity .3s;
    transition: opacity .3s;
    border-radius: 50%;

    svg {
      margin-left: -5px;
      margin-right: 0;
    }
  }

  .el-image {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.el-avatar.userPic:hover {
  .avatar-mask {
    opacity: 1;
  }
}

.popover_topBar {
  right: 15px;
  padding: 0;
  font-size: 12px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px;
  transform: translate(0px, -15px);

  > div {
    > a {
      display: block;
      width: calc(100% - 12px * 2);
      color: rgb(51, 51, 51);
      padding: 0 12px;
    }

    > a:hover {
      color: #111111;
      background-color: #f5f5f5;
    }
  }

  > footer {
    border-top: 1px solid #eeeeee;

    > a {
      text-align: left;
      color: #555555;
      display: block;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 36px;
      line-height: 34px;
      padding: 0 12px;
    }
  }
}

.popover_acc {
  .el-avatar.userPic {
    cursor: default;
  }

  .acc {
    padding: 12px;

    .user {
      display: flex;
      -webkit-box-align: center;
      align-items: center;

      span:last-child {
        margin-left: 12px;
      }
    }

    .oper {
      display: flex;
      margin-top: 10px;

      > a {
        color: $FontColor;
        flex: 1 1 0%;
        padding: 0px 8px;
        border-left: 1px solid #dedede;
        text-align: center;
      }

      > a:first-child {
        border-left: none;
      }

      > a:hover {
        background-color: none !important;
        color: $ThemeColor;
      }
    }
  }

  > footer {
    background: none #f7f7f7;
    display: flex;
    justify-content: center;
  }
}

.menuDrawer {
  .el-drawer__body {
    position: relative;

    header {
      width: 280px;
    }

    .menuWarp {
      height: calc(100% - 2px - #{$headHeight});
      display: flex;
      flex-direction: column;
      padding: $headHeight 0 0;
    }
  }
}
</style>

<style lang="scss">
.el-overlay.menuModal {
  background-color: transparent;
}

.menuDrawer {
  .el-drawer__body {
    .menuWarp {
      .treeMenu {
        font-size: 13px;

        .el-tree-node__content {
          padding-top: 8px !important;
          padding-bottom: 8px !important;

          .element-tree-node-label-wrapper {
            .viewTitle {
              display: flex;
              align-items: center;

              svg {
                font-size: 18px;
                padding-right: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
